import { useEffect, useRef, useState } from 'react';
import { io } from 'socket.io-client';
import { SOCKET_URL } from '../../../core/constants/urls';

export const usePredictionSocket = (initialData, enabled) => {
    const socketRef = useRef(null);
    const timeoutRef = useRef(null);

    const [cachedData, setCachedData] = useState(null);
    const [servedId, setServedId] = useState(null);
    const [error, setError] = useState(null);
    const [loading, setLoading] = useState(true);

    const reset = () => {
        setCachedData(null);
        setError(null);
        setServedId(null);
        setLoading(true);
    };

    useEffect(() => {
        if (!enabled) {
            setLoading(false);
            return;
        }
        if (initialData?._id) {
            setCachedData(initialData);
            setLoading(false);
            return;
        }

        if (!initialData?.requestId) return;

        socketRef.current = io(SOCKET_URL, {
            transports: ['websocket'],
        });

        // set timeout for 3.5 minutes
        timeoutRef.current = setTimeout(() => {
            setError('something-wrong-err');
            setLoading(false);
            if (socketRef.current) {
                socketRef.current.disconnect();
            }
        }, 240000); // 4 minutes

        socketRef.current.on('predict.incoming', (message) => {
            if (message?.type === 'error' || message?.requestId === "REQUEST_IF_OF_REQUEST") {
                setError("internal-server-err");
                setLoading(false);
                clearTimeout(timeoutRef.current);
                socketRef.current.disconnect();
            }
            if (message?.requestId === initialData?.requestId) {
                setServedId(message._id);
                setLoading(false);
                clearTimeout(timeoutRef.current);
                socketRef.current.disconnect();
            }
        });

        socketRef.current.on("connect_error", () => {
            setError("unable-to-connect-err");
            setLoading(false);
            clearTimeout(timeoutRef.current);
        });

        socketRef.current.on("disconnect", (reason) => {
            if (reason === "transport close" || reason === "ping timeout") {
                setError("connection-lost-err");
                setLoading(false);
                clearTimeout(timeoutRef.current);
            }
        });

        return () => {
            reset();
            clearTimeout(timeoutRef.current);
            if (socketRef.current) {
                socketRef.current.disconnect();
            }
        };
    }, [initialData]);

    return { cachedData, error, servedId, loading, reset };
};
